module.exports = __webpack_public_path__ + "48df6123734e94acc05e82e0fc3fb1c6.svg";